import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, nullsafe } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

type Entity = models.RepDTO;
type Column = kea.Grid2Column<Entity>;

/**Columnas fijas del grid */
export const columnasFijasRep: Column[] = [
    { title: "Fecha creación", cell: x => ({ data: kea.toDate(x.FechaCreacion) }) },
    { title: "Serie-Folio", cell: x => ({ data: x.SerieFolio }) },
    { title: "Cliente", cell: x => ({ data: x.NombreCliente }) },
    { title: "Sucursal", cell: x => ({ data: x.NombreSucursal }) },
    { title: "Importe pagado", cell: x => ({ data: kea.formatCurrency(x.ImportePagado) }) },
    { title: "IVA cubierto", cell: x => ({ data: kea.formatCurrency(x.IVA) }) },
    { title: "Retención IVA cubierto", cell: x => ({ data: kea.formatCurrency(x.RetencionIVA) }) },
    { title: "Facturas", cell: x => ({ data: x.FoliosFacturas }) },
    { title: "Forma de pago", cell: x => ({ data: x.ClaveFormaPago + " - " + x.NombreFormaPago }) },
    { title: "REP sust.", cell: x => ({ data: x.FoliosRepSustituidos }) },
    { title: "Fecha de pago", cell: x => ({ data: kea.toDate(x.Pago.FechaPago) }) },
    { title: "UUID", cell: x => ({ data: x.UUID }) },
    { title: "Fecha timbrado", cell: x => ({ data: kea.toDate(x.FechaTimbrado) }) },
    { title: "Estatus cancelación", cell: x => ({ data: nullsafe(x.EstatusDeCancelacion, x => models.EstatusCancelacion[x]) }) },
];

export interface BotonesDeps {
    onVer: (item: Entity) => void;
    onEliminar: (item: Entity) => void;
    onTimbrar: (item: Entity) => void;
    onCancelar: (item: Entity) => void;
    OnObtenerXML: (item: Entity) => void;
    OnObtenerPDF: (item: Entity) => void;
    EnviarCorreo: (item: Entity) => void;
}

function botones(deps: BotonesDeps, permisos: models.Rol): kea.Grid2Column<Entity, undefined> {
    const columna = kea.columnaBotones<Entity>([
        {
            tooltip: "Ver",
            iconClass: fa("eye", "fw"),
            onClick: deps.onVer
        }, {
            tooltip: "Timbrar",
            style: "warning",
            iconClass: fa("bell", "fw"),
            disabled: x => (x.EsTimbrada || x.EsCancelada || !permisos.Facturas.VerBotonTimbrarREP),
            onClick: deps.onTimbrar
        }, {
            tooltip: "Cancelar REP",
            style: "danger",
            iconClass: fa("times-circle-o", "fw"),
            disabled: x => !permisos.Facturas.VerBotonCancelarREP,
            onClick: deps.onCancelar
        }, {
            tooltip: "Obtener XML del REP",
            style: "success",
            iconClass: fa("file-code-o", "fw"),
            disabled: x => !x.EsTimbrada || !permisos.Facturas.VerBotonDescargarREP,
            onClick: deps.OnObtenerXML
        }, {
            tooltip: "Obtener PDF del REP",
            style: "danger",
            iconClass: fa("file-pdf-o", "fw"),
            disabled: x => !x.EsTimbrada || !permisos.Facturas.VerBotonDescargarREP,
            onClick: deps.OnObtenerPDF
        }, {
            tooltip: "Eliminar REP",
            style: "danger",
            iconClass: fa("trash", "fw"),
            disabled: x => x.EsTimbrada || !permisos.Facturas.VerBotonEliminarREP,
            onClick: deps.onEliminar
        }, {
            tooltip: "Enviar correo",
            style: "info",
            disabled: x => x.EsCancelada || !x.EsTimbrada || !permisos.Facturas.VerBotonEnviarCorreoFactura,
            iconClass: fa("envelope", "fw"),
            onClick: deps.EnviarCorreo
        }
    ]);

    return {
        ...columna,
        cell: x => ({
            ...columna.cell(x),
            style: () => ({
                maxWidth: "350px"
            })
        })
    }
}

/**Obtiene las columnas del grid */
export function columnas(deps: BotonesDeps, permisos: models.Rol): kea.Grid2Column<Entity, undefined>[] {
    const cols = [botones(deps, permisos), ...columnasFijasRep];
    const color = kea.applyRowStyleToColumns(cols, x => ({
        background:
            x.EsCancelada ? "rgba(255,0,0,0.3)" :
                !x.EsTimbrada ? "rgba(255,255,0,0.3)" :
                    undefined
    }));

    return color;
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/cobranza/reps/columns.tsx